import { CreditCategory } from '../../lib/lib-shared/types/CreditCategory';

export const CREDIT_CATEGORY_RECORD: Record<CreditCategory, string> = {
  [CreditCategory.PRODUCTION]: 'SAV PRODUCTION',
  [CreditCategory.LOGISTICS]: 'SAV LOGISTIQUE',
  [CreditCategory.COMMERCIAL]: 'COMMERCIAL',
  [CreditCategory.MARKETING]: 'MARKETING',
  [CreditCategory.PREORDER]: 'PRECOMMANDE',
  [CreditCategory.BILLING]: 'SAV FACTURATION',
  [CreditCategory.REFERRAL_SPONSOR]: 'PARRAINAGE PARRAIN',
  [CreditCategory.REFERRAL_REFEREE]: 'PARRAINAGE FILLEUL',
};
